import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVehicleConfigurationQuery } from 'next-common';

interface PimVehicleListState {
  pimVehicleList: IVehicleConfigurationQuery;
}

const initialState: PimVehicleListState = {
  pimVehicleList: null,
};

const pimVehicleListSlice = createSlice({
  name: 'pimVehicleList',
  initialState,
  reducers: {
    setPimVehicleList: (state, action: PayloadAction<IVehicleConfigurationQuery>) => {
      state.pimVehicleList = action.payload;
    },
  },
});

export const { setPimVehicleList } = pimVehicleListSlice.actions;
export default pimVehicleListSlice.reducer;
